import { Typography,Box } from "@mui/material";
import React from "react";
import { useUrlContext } from '../context/urlContext';
import logo from '../logo.svg'; // local logo asset

function StartPage(props){
    const { UrlHelperObj } = useUrlContext();

    return(
        <div style={{minHeight:'calc(100vh - 120px)',
            borderStyle:'none',borderColor:'blue',display:'flex', justifyContent:'center',alignItems:'flex-start', padding:'12px' }}>
                <div>
                    <div style={{minHeight:'50px'}}>
                    </div>
                        <Box style={{width:'100%',maxWidth:400,minHeight:200,textAlign:'center',alignItems:'center',
                        backgroundColor: 'white',
                        }}>
                            {/* display local logo above remote image */}
                            {/*<div  style={{ textAlign:'center', marginBottom:16 }}>
                                <img src={logo} alt="OmniQpon Logo" style={{height:80,  width: 120 }} />
                            </div>*/}
                            {<div  style={{ textAlign:'center'}}>
                                <img style={{width:'100%'}} src={UrlHelperObj.omniqponUrl()} alt="" />
                            </div>}
                        </Box>
                        <div style={{textAlign:'center'}}>
                        <Typography  variant="h4" gutterBottom> Welcome to OmniQpon</Typography>
                        </div>
                    <div style={{minHeight:'50px',borderStyle:'none',borderColor:'blue'}}>
                    </div>
                </div>
        </div>
    );
}
export default StartPage;
